import { OpportunityStatusEnum } from "@repo/api";

export const isClosedLostOrInvalidStatus = (status?: OpportunityStatusEnum) => {
  return (
    status === OpportunityStatusEnum.ClosedLost ||
    status === OpportunityStatusEnum.Invalid
  );
};
